import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Matches the password policy used by the authentication flow. */
export function isStrongPassword(password: string): boolean {
  return (
    password.length >= 8 &&
    password.length <= 20 &&
    /[A-Z]/.test(password) &&
    /\d/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  );
}

export function strongPasswordValidator(control: AbstractControl): ValidationErrors | null {
  const value = String(control.value ?? '');
  return !value || isStrongPassword(value) ? null : { weakPassword: true };
}

export function matchingPasswordValidator(
  passwordKey = 'password',
  confirmationKey = 'password_confirmation',
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get(passwordKey)?.value;
    const confirmation = control.get(confirmationKey)?.value;
    if (!password && !confirmation) return null;
    return password === confirmation ? null : { passwordMismatch: true };
  };
}
